li{white-space:pre-wrap}
/*# sourceMappingURL=task-comment.component.css.map */
